import moment from 'moment';

const PatientDetails = ({ patientId, patient }) => (
  <div className='patient-details'>
    {patient.photoUrl ? (
      <img alt='avatar' src={patient.photoUrl} />
    ) : (
      <span className='default-avatar fa-stack fa-1x'>
        <i className='fas fa-circle fa-stack-2x' />
        <i className='fas fa-user fa-stack-1x fa-inverse' />
      </span>
    )}

    <h3 className='patient-name'>
      {patient.lastName}, {patient.firstName}
    </h3>

    <div className='patient-data-point'>
      <span className='label'>Patient ID</span>
      {patientId}
    </div>

    <div className='patient-data-point'>
      <span className='label'>Birthdate</span>
      {moment(patient.dob).format('l')}
    </div>

    <div className='patient-data-point'>
      <span className='label'>Gender</span>
      {patient.gender === 'M' ? 'Male' : 'Female'}
    </div>

    <div className='patient-data-point'>
      <span className='label'>Chronic Condition</span>
      {patient.chronic_condition ? patient.chronic_condition : 'NONE'}
    </div>
  </div>
);

export default PatientDetails;
